import React from 'react';
import Typography from '@mui/material/Typography';

const renderCellMapper = {
  string: (value) => <Typography>{value}</Typography>,
  number: (value) => <Typography>{value}</Typography>,
};

export default renderCellMapper;
